/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">订单详情</h3>
          <div class="headerButton">
              <span style="line-height: 28px;">退单号：<i>{{orderInfoList.asOid||'--'}}</i></span>
              <div>
                    <el-button v-if="orderInfoList.status<=13?true:false" size="mini" @click="cancleOrder(orderInfoList.bXyOasid)">取消退款</el-button>
                </div>
          </div>
          <el-divider></el-divider>
          <!-- 退单中 商品信息 -->
          <div>
              <el-row class="order_goods">
                    <el-col :span="2"> 
                         <el-image :src="`${orderInfoList.commodity.photos}`">
                              <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"></i>
                              </div>
                          </el-image>
                    </el-col> 
                    <el-col :span="16" class="order_Info_item">
                        <!-- <p>{{orderInfoList.commodity.name}} {{goodsItem.specificationlist[0].name}}</p> -->
                        <p>{{orderInfoList.commodity.name}} <span style="color:#ff6700">{{orderInfoList.commodity.specificationlist.length>0?orderInfoList.commodity.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                        <p>{{orderInfoList.commodity.realprice||orderInfoList.commodity.price}} 元 * {{orderInfoList.commodity.number || 1}}</p>
                    </el-col>

                    <!-- 买家已付款了 退款按钮 -->
                    <el-col :span="4" class="order_Info_item">
                        <!-- 没有物流 先按交易成功算 -->
                        <el-button class="reBackMoney" v-if="orderInfoList.status==2||orderInfoList.status==3?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button>
                        <!-- 没有物流 后期打开 -->
                        <!-- <el-button class="reBackMoney" v-if="orderInfoList.status==2?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button> -->
                    </el-col>  
                </el-row>
          </div>

          <!-- 退款信息 部分-->
          <div v-if="isRefund?true:false">
              <!-- 退款信息 -->
              <el-row class="order_goods">
                    <el-col :span="24" class="info_title">退款信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>退款编号： {{orderInfoList.asOid}}</p>
                        <p>申请时间： {{orderInfoList.createTime}}</p>
                        <p>退款原因： {{reasonType(orderInfoList.reason)}}</p>
                        <p>退款总额： {{orderInfoList.refundAmount}}</p>
                        <p>备注： {{orderInfoList.remarks || '--'}}</p>
                    </el-col>                             
                </el-row>
                <!-- 商家退款处理 -->
                 <el-row class="order_goods">
                    <el-col :span="24" class="info_title">商家退款处理</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>审核状态： {{orderStatus(orderInfoList.status)}}</p>
                    </el-col>                             
                </el-row>

                <el-row class="footer_total">
                    <el-col :span="20">
                        <p>申请金额:</p>
                    </el-col>
                    <el-col :span="4"  class="footer_total_money">
                        <p class="finalTotal">{{orderInfoList.refundAmount||0}} 元</p>
                    </el-col>                             
                </el-row>
          </div>

        </div>
</template>
<script>
import {cancleOrderItem,removeOrderItem,getDictData,remove_after_sale} from '@/api/xunyou'
export default {
  data() {
    return {
        isRefund:0,
        iscancle:false, 
        reasaonList:[],
        orderInfoList:JSON.parse(sessionStorage.getItem("orderDetail")) || [],
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
      if(this.$route.fullPath.indexOf('refund')>0){
          this.isRefund =this.$route.query.refund
      }
      this.backReason()

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //   查询退款原因
    backReason(){
         getDictData({
             key:'b_xy_deal_after_sale_reason'
        }).then(res => {
              if (res.code == 0) {
                  this.reasaonList = res.data
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
        }) 
    },

    // 退款原因转换
    reasonType(type){
        let reason = ''
        this.reasaonList.forEach((item)=>{
            if(item.dictValue == type){
                reason = item.dictLabel
            }
        })
        return reason
    },

      //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 11:
                return '提交退单'
                break;
            case 12:
                 return '退单审核'
                break;
            case 13:
                 return '收货确认'
                break;
            case 14:
                 return '退款确认'
                break;
            case 15:
                 return '收款确认'
                break;
            case 16:
                 return '完成'
                break;
            case 17:
                 return '已拒绝退款'
                break;
            case 18:
                 return '已取消'
                break;
            default:                
                return '--'
        } 
    },


      //   撤销退款申请
     cancleOrder(orderId) {
        this.$confirm('确定取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             remove_after_sale({
                 ids: orderId
             }).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
                setTimeout(()=>{
                    this.$router.push('/refund')
				},500)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('取消失败，请稍后再试！')
            })          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      },

    // 退款
    reBackMoney(goodsItem){
        
        const myRefundInfo = {
            orderNumber:this.orderInfoList.orderNumber,
            goodsItem
        }
        console.log(myRefundInfo,'退库随你啦')
        sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
        this.$router.push('/myRefund')

    }
  },
};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #ff6700;
                // color: white;
                background: #f896521a;
                color: #ff6700;
                border: 1px solid #ff6700;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #ff6700 !important;
                color: white !important;
            }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px;
            box-sizing: border-box;
            .order_Info_item {
                margin-left: 10px;
            }
        }
        .info_title{
            margin: 0 0 15px;
            font-size: 16px;
            font-weight: 400;
            color: #333;
        }
        .info_content{
                color: #757575;
                p{
                    margin-bottom: 4px;
                }
        }
        .footer_total{
                text-align: right;
                color: #757575;
                p{
                    margin: 10px 0;
                }
                .footer_total_money{
                    color: #ff6700;
                    .finalTotal{
                        font-size: 20px;
                    }
                }
                
        }
       button.el-button.reBackMoney.el-button--default.el-button--mini {
            background: #ff674c;
            color: white;
            border: 1px solid #ff674c;
        }
        button.el-button.reBackMoney.el-button--default.el-button--mini:hover {
            background: #f896521a;
            color:  #ff674c;
            border: 1px solid #ff674c;
        }

    }

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/refundDetail.vue